import React, { useState } from 'react';
import { motion } from 'framer-motion';

const HowItWorks = () => {
  const [activeTab, setActiveTab] = useState('integrate');

  const tabVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -20 },
  };

  return (
    <div id="services" className="services section py-16">
      <div className="container mx-auto">
        <div className="row">
          <div className="w-full">
            <div className="section-heading text-center wow fadeInDown" data-wow-duration="1s" data-wow-delay="0.5s">
              <h6 className="text-lg font-semibold">Our Service</h6>
              <h4 className="text-3xl font-bold">Three Easy <em>Steps</em></h4>
              <div className="line-dec my-4 mx-auto w-24 h-1 bg-gray-300"></div>
            </div>
          </div>
          <div className="w-full">
            <div className="naccs">
              <div className="grid">
                <div className="row">
                  <div className="w-full">
                    <div className="menu flex justify-center gap-10 space-x-4">
                      <div className={`first-thumb ${activeTab === 'integrate' ? 'active' : ''}`} onClick={() => setActiveTab('integrate')}>
                        <div className="thumb flex flex-col items-center cursor-pointer">
                          <span className="icon" id="integrate"><img src="assets/images/service-icon-integrate.png" alt="" /></span>
                          <span className="mt-2">Integrate</span>
                        </div>
                      </div>
                      <div className={`${activeTab === 'activate' ? 'active' : ''}`} onClick={() => setActiveTab('activate')}>
                        <div className="thumb flex flex-col items-center cursor-pointer">
                          <span className="icon" id="invite"><img src="assets/images/service-icon-invite.png" alt=""/></span>
                          <span className="mt-2">Activate</span>
                        </div>
                      </div>
                      <div className={`${activeTab === 'grow' ? 'active' : ''}`} onClick={() => setActiveTab('grow')}>
                        <div className="thumb flex flex-col items-center cursor-pointer">
                          <span className="icon" id="grow"><img src="assets/images/service-icon-grow.png" alt="" style={{ padding: '3px' }} /></span>
                          <span className="mt-2">Automate</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="w-full">
                    <motion.div
                      initial="hidden"
                      animate="visible"
                      exit="exit"
                      variants={tabVariants}
                      transition={{ duration: 0.5 }}
                      key={activeTab}
                    >
                      {activeTab === 'integrate' && (
                        <div className="bg-white rounded-3xl shadow-xl p-4">
                          <div className="thumb">
                            <div className="row flex flex-wrap">
                              <div className="w-full lg:w-1/2 flex items-center">
                                <div className="left-text p-4">
                                  <h4 className="text-2xl font-bold">Integrate your Planning Center with JoltChat</h4>
                                  <p className="mt-4">
                                    Integrating with JoltChat is easy. Simply sync your Planning Center account and your church's small groups 
                                    will automatically display in your JoltChat dashboard. From there, you can activate groups, view group statistics, 
                                    and more. Gone are the days of manually updating your groups to be accurate. JoltChat handles it all for you.
                                  </p>
                                  <div className="ticks-list mt-4 space-y-2">
                                    <span className="flex items-center"><i className="fa fa-check text-green-500 mr-2"></i> Access JoltChat dashboard</span>
                                    <span className="flex items-center"><i className="fa fa-check text-green-500 mr-2"></i> Easy Onboarding</span>
                                    <span className="flex items-center"><i className="fa fa-check text-green-500 mr-2"></i> Zero Maintenance</span>
                                    <span className="flex items-center"><i className="fa fa-check text-green-500 mr-2"></i> 24/7 Service</span>
                                  </div>
                                </div>
                              </div>
                              <div className="w-full lg:w-1/2 flex items-center justify-center">
                                <div className="right-image-integrate">
                                  <img src="assets/images/step-1.png" alt="" className="w-full h-auto" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {activeTab === 'activate' && (
                        <div className="bg-white rounded-3xl shadow-xl p-4">
                          <div className="thumb">
                            <div className="row flex flex-wrap">
                              <div className="w-full lg:w-1/2 flex items-center justify-start flex-col">
                                <div className="left-text p-4">
                                  <h4 className="text-2xl font-bold">Activate your groups</h4>
                                  <p className="mt-4">
                                    After integrating, you have full control on which groups you want to activate on JoltChat. 
                                    Simply select which groups you want to be visible on the app and activate them. 
                                  </p>
                                  <div className="ticks-list space-y-2">
                                    <span className="flex items-center"><i className="fa fa-check text-green-500 mr-2"></i> Activate the groups you want</span>
                                    <span className="flex items-center"><i className="fa fa-check text-green-500 mr-2"></i> Fast & Secure</span>
                                    <span className="flex items-center"><i className="fa fa-check text-green-500 mr-2"></i> View insights on your groups</span>
                                  </div>
                                </div>
                              </div>
                              <div className="w-full lg:w-1/2 flex flec-col items-center justify-center">
                                <div className="right-image">
                                  <img src="assets/images/step-2.png" alt="" className="w-full h-auto mb-4" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {activeTab === 'grow' && (
                        <div className="bg-white rounded-3xl shadow-xl p-4">
                          <div className="thumb">
                            <div className="row flex flex-wrap">
                              <div className="w-full lg:w-1/2 flex items-center">
                                <div className="left-text p-4">
                                  <h4 className="text-2xl font-bold">Let JoltChat take care of the rest</h4>
                                  <p className="mt-4">
                                    Once you have activated your groups, our system will take care of the rest. 
                                    As members join groups, you will see your Planning Center automatically updated. 
                                    You will also be able to view group insights in your JoltChat dashboard. We believe your 
                                    best time is spent with people and not updating systems. Let JoltChat handle the rest.
                                  </p>
                                  <div className="ticks-list space-y-2">
                                    <span className="flex items-center"><i className="fa fa-check text-green-500 mr-2"></i> Automatically Updates Planning Center</span>
                                    <span className="flex items-center"><i className="fa fa-check text-green-500 mr-2"></i> View groups on map</span>
                                    <span className="flex items-center"><i className="fa fa-check text-green-500 mr-2"></i> Easily join and share groups on the app</span>
                                  </div>
                                </div>
                              </div>
                              <div className="w-full lg:w-1/2 flex items-center justify-center">
                                <div className="right-image">
                                  <img src="assets/images/step-3.png" alt="" className="w-full h-auto mb-4" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </motion.div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;